var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import moment from "moment/moment";
import ButtonLink from "@/Jetstream/ButtonLink";
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
export default function Pets10Row(_a) {
    var team = _a.team, branch = _a.branch, pets10Form = _a.pets10Form, index = _a.index, certificateNumbers = _a.certificateNumbers;
    var route = useRoute(Ziggy);
    function countUsed(certificateNumbers) {
        if (!certificateNumbers) {
            return "0";
        }
        var count = 0;
        for (var _i = 0, certificateNumbers_1 = certificateNumbers; _i < certificateNumbers_1.length; _i++) {
            var certnum = certificateNumbers_1[_i];
            if (certnum.used_externally || certnum.certificate_id) {
                count++;
            }
        }
        return "".concat(count, " of ").concat(certificateNumbers.length);
    }
    return _jsx(_Fragment, { children: _jsxs("tr", { children: [_jsx("td", __assign({ className: "px-6 py-4 whitespace-nowrap" }, { children: _jsx("div", __assign({ className: "text-sm text-gray-500" }, { children: pets10Form ? moment(pets10Form.created_at).format('D MMM YYYY') : "Individually added numbers" })) })), _jsx("td", __assign({ className: "px-6 py-4 whitespace-nowrap" }, { children: _jsx("div", __assign({ className: "text-sm text-gray-500" }, { children: !certificateNumbers || certificateNumbers.length == 0
                            ? "No numbers yet"
                            : certificateNumbers.length == 1
                                ? "" + certificateNumbers[0].number
                                : "".concat(certificateNumbers[0].number, " - ").concat(certificateNumbers[certificateNumbers.length - 1].number) })) })), _jsx("td", __assign({ className: "px-6 py-4 whitespace-nowrap" }, { children: _jsx("div", __assign({ className: "text-sm text-gray-500" }, { children: countUsed(certificateNumbers) })) })), _jsxs("td", __assign({ className: "px-6 py-4 whitespace-nowrap text-sm" }, { children: [!pets10Form && _jsx(ButtonLink, __assign({ id: "manage_individual", href: route('team.branch.certificate-number.showManualPets10', {
                                team: team,
                                branch: branch
                            }) }, { children: "Manage" })), pets10Form && _jsx(ButtonLink, __assign({ id: "manage_pets10", href: route('team.branch.certificate-number.showPets10', {
                                team: team,
                                branch: branch,
                                pets10Form: pets10Form
                            }) }, { children: "Manage" }))] }))] }) });
}
